import styled from "styled-components";

export const PerfilStyled = styled.div`
	.card {
		margin: 1rem auto;
		padding: 10px 20px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		color: var(--color-white-fixed);

		form {
			margin-top: 1rem;
			display: flex;
			flex-direction: column;
			row-gap: 1rem;
		}
	}
`;
